import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesGetRes extends EntityAttendance {
  public items: EntityAttendance[]  = [];
}
